import { put, takeLatest, call, select } from 'redux-saga/effects';

import { formatError } from '../../../libs';
import checkoutAPI from '../../api/checkout';
import { Types, Creators as CheckoutCreators } from '../../reducers/checkout';
import getState from '../../utils/getState';
import getToken from '../../utils/getToken';

function* getPaymentTypes({ cartId }) {
  try {
    const { cart, app } = yield select(getState);
    const siteId = app.getIn(['config', 'siteId']);
    const token = yield select(getToken);
    const payments = yield call(checkoutAPI.getPaymentTypes, cartId || cart.getIn(['id']), {}, token, siteId);

    yield put(CheckoutCreators.getPaymentTypesSuccess({ payments }));
  } catch (error) {
    yield put(CheckoutCreators.getPaymentTypesError(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.GET_PAYMENT_TYPES_REQUEST, getPaymentTypes);
}
